import request from '../../config/axiosConfig';
import {
  GET_LIST_USERS, GET_USER_INFO, CREATE_USER,
  UPDATE_USER, DELETE_USER, MERGE_USER
} from '../../constants/apiEndPoint';

export const userService = {
  getList: async (data) => {
    const result = await request({ url: GET_LIST_USERS, method: 'POST', data });
    return result?.data?.data;
  },

  getOne: async (data) => {
    const result = await request({ url: GET_USER_INFO, method: 'POST', data });
    return result?.data?.data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_USER, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_USER, method: 'POST', data: { id, ...dataBody } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_USER, method: 'POST', data: { id } });
    return data;
  },

  // Gộp tài khoản: chuyển toàn bộ dữ liệu user_merge sang user_keep, rồi khoá
  // user_merge và đánh dấu ĐÃ GỘP (status = 3). Không hoàn tác được.
  merge: async ({ user_keep, user_merge }) => {
    const { data } = await request({ url: MERGE_USER, method: 'POST', data: { user_keep, user_merge } });
    return data;
  },
};
